import DeleteStep from "./DeleteStep";

export default function ConfirmDelete(props) {

  const { step, steps, setSteps } = props;

  return (
    <div>
      {/* <!-- Button to Open the Modal --> */}
      <button
        type="button"
        className="btn btn-danger"
        data-toggle="modal"
        data-target={`#cofirmrecyclemodal${step._id}`}
      >
        Delete
      </button>

      {/* <!-- The Modal --> */}
      <div className="modal" id={`cofirmrecyclemodal${step._id}`}>
        <div className="modal-dialog">
          <div className="modal-content">

            {/* <!-- Modal Header --> */}
            <div className="modal-header">
              <h4 className="modal-title">Confirm</h4>
              <button type="button" className="close" data-dismiss="modal">&times;</button>
            </div>

            {/* <!-- Modal body --> */}
            <div className="font-size-22">
              This step will be definitely deleted

            </div>

            {/* <!-- Modal footer --> */}
            <div className="modal-footer">
              <DeleteStep step={step} steps={steps} setSteps={setSteps}/>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
